import React from "react";
import Button from "../Button/Button";
import { ButtonVariant } from "../../types/button";

interface ProductCatalogueIntroProps {
  introduction: string;
  buttonText: string;
  buttonLink: string;
  buttonVariant: ButtonVariant;
}

export const ProductCatalogueIntro: React.FC<ProductCatalogueIntroProps> = ({
  introduction,
  buttonText,
  buttonLink,
  buttonVariant,
}) => {
  const handleClick = () => {
    window.open(buttonLink, "_self");
  };

  return (
    <div className="hidden md:flex flex-col w-full items-center pb-36">
      {introduction && (
        <div className="mb-10 text-primary max-w-[770px] flex justify-center text-center">
          {introduction}
        </div>
      )}
      {buttonText && (
        <Button
          text={buttonText}
          variant={buttonVariant}
          onClick={handleClick}
        />
      )}
    </div>
  );
};
